"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template3OurTeam = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-3-our-team.scss");

function Template3OurTeam(_ref) {
  var imageUrl = _ref.imageUrl,
      name = _ref.name,
      jobPosition = _ref.jobPosition,
      description = _ref.description,
      className = _ref.className;
  return react_1.default.createElement("div", {
    className: "ourTeam flex relative max-w-367px sm:max-w-335px ".concat(className.wrapper)
  }, react_1.default.createElement("div", {
    className: "w-full items-center"
  }, react_1.default.createElement("img", {
    src: imageUrl,
    alt: "reviewer avatar",
    className: "w-full h-auto avatar ".concat(className.image)
  }), react_1.default.createElement("div", {
    className: "mt-31px "
  }, name && react_1.default.createElement("div", {
    className: "title ".concat(className.title)
  }, name), jobPosition && react_1.default.createElement("div", {
    className: "subtitle mb-10px ".concat(className.jobPosition)
  }, jobPosition), react_1.default.createElement("div", {
    className: "rectangle  ".concat(className.rectangle)
  }), description && react_1.default.createElement("div", {
    className: " font-16px mt-22px  ".concat(className.description)
  }, description))));
}

exports.Template3OurTeam = Template3OurTeam;
Template3OurTeam.propTypes = {
  imageUrl: prop_types_1.default.string,
  name: prop_types_1.default.string,
  jobPosition: prop_types_1.default.string,
  description: prop_types_1.default.string,
  className: prop_types_1.default.object
};
Template3OurTeam.defaultProps = {
  imageUrl: '',
  name: 'Corey Baptista',
  jobPosition: 'CEO',
  description: 'There was that time artists at Sequence  to hand-Sharpie the lorem ipsum passage on a line of paper bags they designed for Chipotle inside joke',
  className: {
    wrapper: '',
    image: '',
    title: '',
    jobPosition: '',
    rectangle: '',
    description: ''
  }
};